import * as React from "react";
import { DateInput } from "./dateInput";
import { getJavaDate, stringInputParseDate, stringInputFormatDate } from "./baseFormating";
import { parseISO } from "date-fns";
import { csLocalizer } from "./csLocalizer";

export type IStringDateInputProps = Omit<
    React.ComponentProps<typeof DateInput>,
    "value" | "onChange" | "onBlur" | "onFocus" | "formatDate" | "parseDate"
> & {
    value: string;
    onChange?: (newValue: string) => void;
    onBlur?: (newValue: string) => void;
    onFocus?: (newValue: string) => void;
    disabled?: boolean;
    required?: boolean;
};

export class StringDateInput extends React.PureComponent<IStringDateInputProps> {
    render() {
        const { value, onChange, onBlur, onFocus, disabled, required, inputProps, ...other } = this.props;

        const realValue: Date | null = value === "" || value === null || value === undefined ? null : parseISO(value);
        return (
            <DateInput
                localeUtils={csLocalizer}
                {...other}
                onChange={selectedDate => {
                    if (selectedDate instanceof Date && isNaN(selectedDate as any)) {
                        // ignore change - leave last valid date
                    } else if (selectedDate === null) {
                        onChange?.("");
                    } else {
                        onChange?.(getJavaDate(selectedDate));
                    }
                }}
                onBlur={selectedDate => {
                    onBlur?.(getJavaDate(selectedDate));
                }}
                onFocus={selectedDate => {
                    onFocus?.(getJavaDate(selectedDate));
                }}
                value={realValue}
                formatDate={stringInputFormatDate}
                parseDate={stringInputParseDate}
                disabled={disabled}
                inputProps={{ ...inputProps, disabled, required }}
            />
        );
    }
}
